export default function pluralize(word, count, unit, onlyReturnUnit = false) {
    const countStr = onlyReturnUnit ? '' : `${count}${unit ? ` ${unit}` : ''}`;

    if (count <= 1) {
        return `${countStr} ${word}`;
    }

    // Exceptions et règles
    const exceptionsAUEAU = ["pneu", "landau", "bleu"];
    // pour -au / -eau / -eu : normalement on ajoute un 'x', sauf si c'est un de ces mots, on ajoute 's'

    const exceptionsAL = ["festival", "chacal", "bal", "carnaval", "récital"];
    // pour -al : normalement on remplace -al par -aux, sauf exceptions ci-dessus où on ajoute juste un 's'

    const exceptionsAIL = {
        "corail": "coraux",
        "travail": "travaux",
        "vitrail": "vitraux",
        "bail": "baux"
    };
    // pour -ail : normalement on ajoute 's', sauf ces exceptions où -ail devient -aux

    const exceptionsOU = ["bijou", "chou", "genou", "caillou", "hibou", "joujou", "pou"];
    // pour -ou : normalement on ajoute 's', sauf exceptions ci-dessus où on ajoute un 'x'


    const lowerWord = word.toLowerCase();

    // 1. Terminaison en -al
    if (lowerWord.endsWith("al")) {
        const base = word.slice(0, -2);
        if (!exceptionsAL.includes(lowerWord)) {
            // On remplace -al par -aux
            return `${countStr} ${base}aux`;
        } else {
            // Exception => juste un 's'
            return `${countStr} ${word}s`;
        }
    }

    // 2. Terminaison en -ail
    if (lowerWord.endsWith("ail")) {
        if (Object.keys(exceptionsAIL).includes(lowerWord)) {
            // Exception => forme déjà définie
            return `${countStr} ${exceptionsAIL[lowerWord]}`;
        } else {
            // Pas dans les exceptions => on ajoute 's'
            return `${countStr} ${word}s`;
        }
    }

    // 3. Terminaison en -au / -eau / -eu
    if (lowerWord.endsWith("eau") || lowerWord.endsWith("au") || lowerWord.endsWith("eu")) {
        if (exceptionsAUEAU.includes(lowerWord)) {
            // Exception => on ajoute 's'
            return `${countStr} ${word}s`;
        } else {
            // On remplace la terminaison par la même racine + 'x'
            return `${countStr} ${word}x`;
        }
    }

    // 4. Terminaison en -ou
    if (lowerWord.endsWith("ou")) {
        if (exceptionsOU.includes(lowerWord)) {
            // Exception => on ajoute 'x'
            return `${countStr} ${word}x`;
        } else {
            // Normalement => on ajoute 's'
            return `${countStr} ${word}s`;
        }
    }

    // Si aucune règle spéciale ne s'applique, on ajoute simplement un 's'
    return `${countStr} ${word}s`;
}